import { IsMobileDevice } from 'source/app/domain/Device/Helpers/IsMobile';
import { Or } from 'source/app/domain/Or';
import { IToolsState } from 'source/app/presentation/Header/Tools/ToolsState';
import { ArrayUtils } from 'source/app/services/ArrayUtils';
import Intervals from '../../Intervals';
import Maths from '../../Maths';
import { Sounds } from '../../Sound/Sounds';
import { ESharedComponent } from '../State/ESharedComponent';
import { State } from '../State/State';
import UI from '../UI';
const cashJS = require('cash-dom');

export const StopGarble = () => {
	Intervals.Stop('garble');

	State.ReadClass<IToolsState>(ESharedComponent.Tools).setState({
		garbleEnabled: false,
		garbleHowl: undefined
	});

	cashJS('#calcTarget_appBodyCopy').remove();
	cashJS('#calcTarget_appBody').css('display', 'block');
};

export const ToggleGarbleAnimation = () => {
	if (IsMobileDevice()) {
		return;
	}

	const isEnabled = State.ReadClass<IToolsState>(ESharedComponent.Tools).state
		.garbleEnabled;
	isEnabled ? StopGarble() : StartGarble({ playSounds: true });

	State.ReadClass<IToolsState>(ESharedComponent.Tools).setState({
		garbleEnabled: !isEnabled
	});
};

interface IGarbleOptions {
	playSounds: boolean;
}

export const StartGarble = (options: IGarbleOptions) => {
	if (IsMobileDevice()) {
		return;
	}

	const tools = State.ReadClass<IToolsState>(ESharedComponent.Tools);

	if (!tools) {
		return;
	}

	const isAlreadyRunning = tools.state.garbleEnabled;

	if (isAlreadyRunning) {
		return;
	}

	tools.setState({
		garbleEnabled: true
	});

	cashJS('#calcTarget_appBody')
		.clone()
		.prop('id', 'calcTarget_appBodyCopy')
		.appendTo('#pnlHome');

	cashJS('#calcTarget_appBody').css('display', 'none');

	const targetSelector = '#calcTarget_appBodyCopy';
	const targetElements = cashJS(targetSelector)
		.find(':not(iframe)')
		.find(':not(.garble-exclude)')
		.contents();

	const numElements = targetElements.length;
	const intervalPeriod = numElements / (!IsMobileDevice() ? 4 : 2);

	Intervals.Start({
		name: 'garble',
		execute: () => GarbleElements(targetElements, options),
		period: intervalPeriod
	});
};

const GetASCIIString = (numberOfCharacters: number) => {
	var result = [];
	for (var index = 0; index < numberOfCharacters; index++) {
		var character = GetRandomASCIICharacter();
		result.push(character);
	}
	return result.join('');
};

const GetRandomASCIICharacter = () => {
	// Returns character between ASCII numbers 33 and 94
	var randomNumber = Maths.GetSingleRandomNumber(62);
	var randomCharacter = String.fromCharCode(32 + randomNumber);
	return randomCharacter;
};

const GarbleElements = (elements: any, options: IGarbleOptions) => {
	elements.each(function() {
		const randomOpacity = 0.8 + Maths.GetSingleRandomNumber(2) / 10;
		const randomColor = UI.GetRandomYellowColor();
		const randomFontWeight =
			Maths.GetSingleRandomNumber(5) === 5 ? 'bold' : 'normal';
		const randomFontStyle =
			Maths.GetSingleRandomNumber(10) === 10 ? 'italic' : 'normal';

		cashJS(this)
			.css('opacity', String(randomOpacity))
			.css('color', randomColor)
			.css('font-weight', randomFontWeight)
			.css('font-style', randomFontStyle);

		if (this.nodeType == 3) this.data = GetASCIIString(this.data.length);
	});

	const shouldPlaySound = Or(options.playSounds, false);

	if (shouldPlaySound) {
		PlayRandomMarchingSound();
	}
};

const PlayRandomMarchingSound = () => {
	const randomMarchingSound = ArrayUtils.GetRandomElement([
		Sounds.marching1,
		Sounds.marching2,
		Sounds.marching3,
		Sounds.marching4
	]);

	randomMarchingSound.Play();
};
